import { reportConstants } from '../constants/report.constants';
import reportService from '../services/report.service';
import { alertActions } from './alert.actions';
import { b64toBlob } from '../helpers/base64';

export const reportActions = {
  fetchWorkJourney,
  fetchIntegrationLog,
  fetchRequestsPerManager,
  fetchNotifications,
  fetchLastContact,
  fetchAccess,
};

function fetchWorkJourney(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const workJourneyRegisters = await reportService.fetchWorkJourney(params);    
      if (params.export && workJourneyRegisters.file) {        
        const blob = b64toBlob(workJourneyRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'historico-jornada.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(workJourneyRegisters));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.WORKJOURNEY_FETCH_REQUEST } }
  function success(workJourneyRegisters) { return { type: reportConstants.WORKJOURNEY_FETCH_SUCCESS, workJourneyRegisters } }
  function failure(error) { return { type: reportConstants.WORKJOURNEY_FETCH_FAILURE, error } }
}

function fetchIntegrationLog(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const integrationLogs = await reportService.fetchIntegrationLog(params);      
      dispatch(success(integrationLogs));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.INTEGRATIONLOG_FETCH_REQUEST } }
  function success(integrationLogs) { return { type: reportConstants.INTEGRATIONLOG_FETCH_SUCCESS, integrationLogs } }
  function failure(error) { return { type: reportConstants.INTEGRATIONLOG_FETCH_FAILURE, error } }
}

function fetchRequestsPerManager(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const integrationLogs = await reportService.fetchRequestsPerManager(params);      
      dispatch(success(integrationLogs));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.INTEGRATIONLOG_FETCH_REQUEST } }
  function success(integrationLogs) { return { type: reportConstants.INTEGRATIONLOG_FETCH_SUCCESS, integrationLogs } }
  function failure(error) { return { type: reportConstants.INTEGRATIONLOG_FETCH_FAILURE, error } }
}

function fetchNotifications(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const notifications = await reportService.fetchNotifications(params);      
      dispatch(success(notifications));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.NOTIFICATION_FETCH_REQUEST } }
  function success(notifications) { return { type: reportConstants.NOTIFICATION_FETCH_SUCCESS, notifications } }
  function failure(error) { return { type: reportConstants.NOTIFICATION_FETCH_FAILURE, error } }
}

function fetchLastContact(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const lastContactRegisters = await reportService.fetchLastContact(params);    
      if (params.export && lastContactRegisters.file) {        
        const blob = b64toBlob(lastContactRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'ultimo-contato.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(lastContactRegisters));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.LASTCONTACT_FETCH_REQUEST } }
  function success(lastContactRegisters) { return { type: reportConstants.LASTCONTACT_FETCH_SUCCESS, lastContactRegisters } }
  function failure(error) { return { type: reportConstants.LASTCONTACT_FETCH_FAILURE, error } }
}

function fetchAccess(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const accessRegisters = await reportService.fetchAccess(params);    
      if (params.export && accessRegisters.file) {        
        const blob = b64toBlob(accessRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'acesso.xlsx');
        tempLink.click();        
      } else {
        dispatch(success(accessRegisters));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportConstants.ACCESS_FETCH_REQUEST } }
  function success(accessRegisters) { return { type: reportConstants.ACCESS_FETCH_SUCCESS, accessRegisters } }
  function failure(error) { return { type: reportConstants.ACCESS_FETCH_FAILURE, error } }
}